import * as React from 'react';
import { createElement } from 'react';
import { Select } from '@alifd/next';
import wrapper from './next-wrapper';
import request from '@/utils/request';
import TitleTooltip from '@/components/table/pro-table/components/tooltip-title';
import { isEmpty } from 'lodash-es';
const DictSelect = (props, ref) => {
    const dictMapRef = React.useRef(new Map());
    const [dataSource, setDataSource] = React.useState([]);
    const { dict: dictsArray, __designMode, value, showTitleTooltip, hasClear = true, showSearch = true, ...restProps } = props;
    const parentDict = dictsArray?.[0];
    const dict = dictsArray?.[dictsArray?.length - 1];
    const isDesign = __designMode === 'design';
    const getCurrentDict = React.useCallback(async () => {
        const { content = [] } = await request.get(`/api/exchange/dictionary/type/values/${dict}`);
        return content;
    }, [dict]);
    const resaveDict = React.useCallback(async (dictTypeCd) => {
        const { content = [] } = await request.get(`/api/exchange/dictionary/type/parent/values/${dictTypeCd}`);
        const currentDict = await getCurrentDict();
        const dicts = content?.map(({ val, valDesc }) => ({ name: valDesc, value: val }));
        const dataSource = dicts?.filter((item) => currentDict?.find((r) => r?.val === item.value));
        setDataSource(dataSource);
        dictMapRef.current?.set(dictTypeCd, dicts);
        localStorage.setItem('dictMap', JSON.stringify(Array.from(dictMapRef.current?.entries())));
    }, [getCurrentDict]);
    const setDict = React.useCallback(async () => {
        const currentDict = await getCurrentDict();
        const targetDict = dictMapRef.current?.get(parentDict) || [];
        if (!isEmpty(targetDict)) {
            const dataSource = targetDict?.filter((item) => currentDict?.find((r) => r?.val === item.value));
            setDataSource(dataSource);
        }
        else {
            resaveDict(parentDict);
        }
    }, [getCurrentDict, parentDict, resaveDict]);
    React.useEffect(() => {
        if (isDesign) {
            return;
        }
        const dictMap = new Map(JSON.parse(localStorage.getItem('dictMap')));
        dictMapRef.current = dictMap;
        if (dictMap.size === 0) {
            resaveDict(parentDict);
        }
        else {
            setDict();
        }
    }, [dict, isDesign, parentDict, resaveDict, setDict]);
    const renderPreview = () => {
        const val = dataSource.find((item) => item.value === value)?.name;
        if (showTitleTooltip) {
            return createElement(TitleTooltip, null, val);
        }
        return createElement("span", null, val);
    };
    return (createElement(Select, { ...restProps, ref: ref, value: value, dataSource: dataSource?.map(({ name: label, value }) => ({ label, value })), renderPreview: renderPreview, hasClear: hasClear, showSearch: showSearch }));
};
export const DictSelectRef = React.forwardRef(DictSelect);
const FormDictSelect = wrapper(DictSelectRef, 'CbayelFormDictSelect');
export default FormDictSelect;
